import React, { memo, ReactNode, useMemo } from "react";
import { Box, Flex } from "@chakra-ui/react";

import { useRouter } from "next/router";
import { AdminLeftNav } from "modules/admin/admin-left-nav";
import { ADMIN_PATH, INTERNAL_ADMIN_PATH } from "modules/utils/Constants";
import { InternalAdminLeftNav } from "modules/internal-admin/components/internal-admin-left-nav";
import { LeftNav } from "./left-nav";

interface IProps {
  children?: ReactNode;
}

const LeftNavLayout = ({ children }: IProps) => {
  const { pathname } = useRouter();

  const isAdmin = useMemo(() => pathname.startsWith(ADMIN_PATH), [pathname]);
  const isInternalAdmin = useMemo(
    () => pathname.startsWith(INTERNAL_ADMIN_PATH),
    [pathname],
  );

  if (isAdmin) {
    return (
      <Flex h="100dvh">
        <Box w={280}>
          <AdminLeftNav />
        </Box>
        {children}
      </Flex>
    );
  }

  if (isInternalAdmin) {
    return (
      <Flex h="100dvh">
        <Box w={280}>
          <InternalAdminLeftNav />
        </Box>
        {children}
      </Flex>
    );
  }

  return (
    <Flex h="100dvh">
      <Box w={280}>
        <LeftNav />
      </Box>
      {children}
    </Flex>
  );
};

export default memo(LeftNavLayout);
